/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SimpleCircularTimer":"SimpleCircularTimer_Q49il","svgRoot":"svgRoot_rT7+g","circle":"circle_Qohtq","seconds":"seconds_E87gh"};